"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = searchList;
/**
 * searches a list with a semi decent ranking algorithm that considers
 * different parts of each word and the query
 */

function searchList(list, getListString, query) {
  if (!query) return list;
  var queryParts = query.toLowerCase().split(' ').map(function (x) {
    return x.trim();
  }).filter(function (x) {
    return !!x;
  });
  return list.map(function (item) {
    return {
      item: item,
      normalized: getListString(item).toLowerCase().split(' ').map(function (subword) {
        return subword.trim();
      }).filter(function (x) {
        return !!x;
      })
    };
  }).map(function (_ref) {
    var item = _ref.item,
        normalized = _ref.normalized;
    return {
      item: item,
      rank: normalized.reduce(function (wordRank, subword) {
        return wordRank + queryParts.reduce(function (partRank, queryPart) {
          // if the `subword` matches a `queryPart` exactly, rank it higher
          if (subword === queryPart) return partRank + 3; // if it only starts with the query part, rank it, but lower

          if (subword.startsWith(queryPart)) return partRank + 2;
          return partRank;
        }, 0);
      }, 0)
    };
  }).filter(function (_ref2) {
    var rank = _ref2.rank;
    return rank > 0;
  }).sort(function (a, b) {
    return b.rank - a.rank;
  }) // descending
  .map(function (_ref3) {
    var item = _ref3.item;
    return item;
  });
}